const REDIRECT_KEY = 'els.auth.redirect';

export const storeRedirectTarget = (path: string) => {
  if (!path.startsWith('/') || path.startsWith('/login')) {
    return;
  }
  window.localStorage.setItem(REDIRECT_KEY, path);
};

export const readRedirectTarget = (): string => {
  const path = window.localStorage.getItem(REDIRECT_KEY);

  return path?.startsWith('/') && !path.startsWith('/login') ? path : '/dashboard';
};

export const clearRedirectTarget = () => {
  window.localStorage.removeItem(REDIRECT_KEY);
};
